import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import { useId } from 'react';

/** Render a labeled display setting in the shared settings layout. */
const AccessibilitySetting = ({
  label,
  ariaLabel = label,
  options,
  value,
  onChange,
  isOptionDisabled,
  inputId,
}) => {
  const generatedId = useId();
  const controlId = inputId ?? generatedId;

  return (
    <div className="user-menu-setting-row">
      <label htmlFor={controlId} className="user-menu-setting-label">
        {label}
      </label>
      <BaseSelect
        inputId={controlId}
        styles={{
          container: (base) => ({
            ...base,
            width: '100%',
          }),
        }}
        selectProps={{
          'aria-label': ariaLabel,
          options,
          value: findSelectOption(options, value),
          isOptionDisabled,
          onChange: (option) => onChange(option?.value ?? ''),
        }}
      />
    </div>
  );
};

export default AccessibilitySetting;
